module.exports = __webpack_public_path__ + "static/media/thumbnail.3da49ae4.jpg";